 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~c714bc7b": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~c714bc7b": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account~31ecd969":"account~31ecd969","automate~f71cff67":"automate~f71cff67","bwns~21833f8f":"bwns~21833f8f","book~core~748942c6":"book~core~748942c6","book~31ecd969":"book~31ecd969","core~31ecd969":"core~31ecd969","faq~748942c6":"faq~748942c6","suggestions~748942c6":"suggestions~748942c6","vendors~nft~253ae210":"vendors~nft~253ae210","nft~748942c6":"nft~748942c6","vendors~palette~253ae210":"vendors~palette~253ae210","palette~f71cff67":"palette~f71cff67","contrib~21833f8f":"contrib~21833f8f","creator~31ecd969":"creator~31ecd969","daico~f71cff67":"daico~f71cff67","dumbapps~cf837fdf":"dumbapps~cf837fdf","gift~f71cff67":"gift~f71cff67","hourglass~f71cff67":"hourglass~f71cff67","kyc~8c05360c":"kyc~8c05360c","locks~31ecd969":"locks~31ecd969","login~f71cff67":"login~f71cff67","qc~31ecd969":"qc~31ecd969","qe~f71cff67":"qe~f71cff67","smart~f71cff67":"smart~f71cff67","transaction~57aca511":"transaction~57aca511","wallet~f71cff67":"wallet~f71cff67"}[chunkId]||chunkId) + "." + {"account~31ecd969":"2163365a","automate~f71cff67":"340c6c25","bwns~21833f8f":"8a12a0aa","chunk-2d0dea77":"9e176534","book~core~748942c6":"90400f69","book~31ecd969":"9e20d8c5","core~31ecd969":"d26cfe22","faq~748942c6":"b6552b92","suggestions~748942c6":"38b1a88b","vendors~nft~253ae210":"66a5c068","nft~748942c6":"07746256","vendors~palette~253ae210":"eeb39e21","palette~f71cff67":"4b6966c6","contrib~21833f8f":"02c8c3bf","creator~31ecd969":"f1739d5e","daico~f71cff67":"5f5182f6","dumbapps~cf837fdf":"46faaf7f","gift~f71cff67":"30401d34","hourglass~f71cff67":"f2a42a43","kyc~8c05360c":"7f318530","locks~31ecd969":"28f9c2f1","login~f71cff67":"38c161bd","qc~31ecd969":"c3fbb20f","qe~f71cff67":"eabbfb1d","smart~f71cff67":"e9568436","transaction~57aca511":"c65d863f","wallet~f71cff67":"6f4f2fa1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account~31ecd969":1,"automate~f71cff67":1,"bwns~21833f8f":1,"book~core~748942c6":1,"book~31ecd969":1,"core~31ecd969":1,"faq~748942c6":1,"nft~748942c6":1,"palette~f71cff67":1,"contrib~21833f8f":1,"creator~31ecd969":1,"dumbapps~cf837fdf":1,"gift~f71cff67":1,"hourglass~f71cff67":1,"locks~31ecd969":1,"login~f71cff67":1,"qc~31ecd969":1,"qe~f71cff67":1,"smart~f71cff67":1,"transaction~57aca511":1,"wallet~f71cff67":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account~31ecd969":"account~31ecd969","automate~f71cff67":"automate~f71cff67","bwns~21833f8f":"bwns~21833f8f","book~core~748942c6":"book~core~748942c6","book~31ecd969":"book~31ecd969","core~31ecd969":"core~31ecd969","faq~748942c6":"faq~748942c6","suggestions~748942c6":"suggestions~748942c6","vendors~nft~253ae210":"vendors~nft~253ae210","nft~748942c6":"nft~748942c6","vendors~palette~253ae210":"vendors~palette~253ae210","palette~f71cff67":"palette~f71cff67","contrib~21833f8f":"contrib~21833f8f","creator~31ecd969":"creator~31ecd969","daico~f71cff67":"daico~f71cff67","dumbapps~cf837fdf":"dumbapps~cf837fdf","gift~f71cff67":"gift~f71cff67","hourglass~f71cff67":"hourglass~f71cff67","kyc~8c05360c":"kyc~8c05360c","locks~31ecd969":"locks~31ecd969","login~f71cff67":"login~f71cff67","qc~31ecd969":"qc~31ecd969","qe~f71cff67":"qe~f71cff67","smart~f71cff67":"smart~f71cff67","transaction~57aca511":"transaction~57aca511","wallet~f71cff67":"wallet~f71cff67"}[chunkId]||chunkId) + "." + {"account~31ecd969":"d3147feb","automate~f71cff67":"169e9226","bwns~21833f8f":"52c0a6de","chunk-2d0dea77":"31d6cfe0","book~core~748942c6":"42b3e6bf","book~31ecd969":"d845ffa5","core~31ecd969":"3f50e065","faq~748942c6":"44732243","suggestions~748942c6":"31d6cfe0","vendors~nft~253ae210":"31d6cfe0","nft~748942c6":"6b45a5bc","vendors~palette~253ae210":"31d6cfe0","palette~f71cff67":"b0ac4b20","contrib~21833f8f":"6a5fe1c6","creator~31ecd969":"59856c94","daico~f71cff67":"31d6cfe0","dumbapps~cf837fdf":"a1f28fcf","gift~f71cff67":"78b5d9cf","hourglass~f71cff67":"c0cd4ec0","kyc~8c05360c":"31d6cfe0","locks~31ecd969":"6f13e3c6","login~f71cff67":"98ac7e40","qc~31ecd969":"969678ce","qe~f71cff67":"bc6a0977","smart~f71cff67":"ad3a405c","transaction~57aca511":"adeb92a6","wallet~f71cff67":"5027d72f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([12,"chunk-web3~7274e1de","chunk-book-vendors~2a42e354","chunk-bookpage-vendors~28eba0a1","app~493df0b3","app~d0ae3f07","app~2a42e354","app~1f20a385","app~9c5b28f6","app~ec8c427e","app~cfbf0a2e","app~06837ae4"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
